//  <vaadin-date-picker i18n="[[format_vaadinDatePickerI18N]]"></vaadin-date-picker>
const vaadinDatePickerI18N_parseDate = (text) => {
    if (!text) return;

    const parts = text.replace(/T.+/i, '').replace(/\//g, '-').split('-') // normalize and split into y/m/d values
        ,today = new Date();
    let date
        ,month = today.getMonth()
        ,year = today.getFullYear();

    if (parts.length === 3) { // YYYY MM DD
        year = parseInt(parts[0]);
        if (parts[0].length < 3 && year >= 0) {
            year += year < 50 ? 2000 : 1900;
        }
        month = parseInt(parts[1]) - 1;
        date = parseInt(parts[2]);
    } else if (parts.length === 2) { // MM DD
        month = parseInt(parts[0]) - 1;
        date = parseInt(parts[1]);
    } else if (parts.length === 1) { // DD
        date = parseInt(parts[0]);
    }

    if (date !== undefined) {
        return { day: date, month, year };
    }
};
const vaadinDatePickerI18N = {
    monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    firstDayOfWeek: 0,
    week: 'Week',
    calendar: 'Calendar',
    clear: 'Clear',
    today: 'Today',
    cancel: 'Cancel',
    formatDate: (date) => {
        if (!date) {
            return "";
        }

        if (date instanceof Date) {
            date = date.toISOString();
            return date.split('T')[0];
        }
        else if (typeof date === 'string') {
            date = vaadinDatePickerI18N_parseDate(date);
        }

        // else assume format is {year, month, day} object...
        const yearStr = String(date.year).replace(/\d+/, (y) => '0000'.substr(y.length) + y);
        return [yearStr, date.month + 1, date.day].join('-'); // output to yyyy-mm-dd
    },
    parseDate: vaadinDatePickerI18N_parseDate,
    formatTitle: (monthName, fullYear) => {
        return monthName + ' ' + fullYear;
    }
};

export const format = {
    /**
     * Format an address, adding commas as necessary.
     * @param {...any} addressParts
     */
    address(...addressParts) {
        return addressParts.reduce((result, part) => {
            if(part)
                part = '' + part;
            if (!part || !part.trim().length)
                return result;

            if (result.length)
                result += ', ';

            return result + part;
        }, '');
    },

    /**
     * Format an phone number, adding commas and brakets as necessary.
     * @param {any} phoneNumber
     */
    phone(phoneNumber) {
        if (!phoneNumber || phoneNumber.trim().length <= 0)
            return "";

        // we reverse the phoneNumber in order to be able to get what we want with a simple regex expression
        const reverse = (str) => str.split('').reverse().join('');

        const revNumber = reverse(phoneNumber).replace(/\D/g, ''); // clean phonenumber up and remove anything that isn't a digit

        const match = revNumber.match(/^(\d{4})(\d{3})(\d{1,3})?(\d)?$/); // Group digits.

        if (!match)
            return phoneNumber;

        return (match[4] ? "+" + reverse(match[4]) + " " : "") +
            (match[3] ? "(" + reverse(match[3]) + ") " : "") +
            (match[2] ? reverse(match[2]) + "-" : "") +
            (match[1] ? reverse(match[1]) : ""); 
    },

    /**
     * Format a string and return numbers only, strips all none digits.
     * @param {any} string
     */
    digitsOnly(string) {
        if (!string)
            return string;

        return string.replace(/\D/g, '');
    },

    /**
     * Format a number/string to have commas. Ie. 95,000 instead of 95000
     * @param {any} x
     */
    numberWithCommas(x) {
        if (!x || x.length == 0)
            return "";
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    /**
     * Formats a number as currency. optionally remove commas
     * Eg. 1234.567 -> 1,234.58
     * 
     * format_currency
     */
    currency(amount, removeCommas = false, minFractionDigits = 2, maxFractionDigits = 2, negativeAsBrackets = false) {
        if (!amount || !parseFloat(amount))
            return "0.00";

        amount = parseFloat(amount).toFixed(maxFractionDigits); // Round the number to specified digits.

        let formattedCurrency = parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: minFractionDigits, maximumFractionDigits: maxFractionDigits });

        if (removeCommas == true)
            formattedCurrency = formattedCurrency.replace(",", "");

        if (negativeAsBrackets)
            return parseFloat(amount) < 0 ? `(${formattedCurrency.replace("-", "")})` : formattedCurrency;
        else
            return formattedCurrency;        
    },

    rate(amount) {
        return format.currency(amount, false, 0, 4);
    },

    dealRate(rates) {
        if (!rates || rates.length <= 0)
            return;

        let rate = "";
        for (let i = 0; i < rates.length; i++) {
            rate += (String.Format("{0:0.00}", r.RangeStart) + "-" + (r.RangeEnd == 0 || r.RangeEnd == null ? "Infinity" : String.Format("{0:0.00}", r.RangeEnd)) + (", ") +
                (r.IsPercent ? "" : "$") + String.Format("{0:0.00}", r.Rate) + (r.IsPercent ? "%" : "") + (r.RangeEnd == 0 || r.RangeEnd == null ? "" : rateSeperator));
        }
        return rate;
    },

    /**
     * Output Example: FRI MAY 08 2020
     *
     * format_dateWMDY(dateString)
     */
    dateWMDY(dateString) {
        if (!dateString)
            return "";

        return (new Date(dateString)).toDateString();
    },

    /**
     * Output Example: May 8, 2020
     *
     * format_date(dateString)
     */
    date(dateString) {
        if (!dateString)
            return "";

        const d = new Date(dateString);
        return `${d.toLocaleString('default', { month: 'short' })} ${d.getDate()}, ${d.getFullYear()}`;
    },

    /**
     * Output Example: May 8, 2020
     *
     * format_dateUTC(dateString)
     */
    dateUTC(dateString) {
        if (!dateString)
            return "";

        const d = new Date(dateString);
        return `${d.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
    },

    /**
     * Output Example: May 8, 2020 @ 15:23:55
     *
     * format_dateTime(dateString)
     */
    dateTime(dateString) {
        if (!dateString)
            return "";

        const d = new Date(dateString);
        return `${d.toLocaleString('default', { month: 'short' })} ${d.getDate()}, ${d.getFullYear()} @ ${("00" + d.getHours()).slice(-2)}:${("00" + d.getMinutes()).slice(-2)}:${("00" + d.getSeconds()).slice(-2)}`;
    },

    /**
     * Helper to format datetime into date (only) string. This is necessary for vaadin-date-picker value.
     * Eg: "2018-05-23T12:30:00" -> "2018-05-23"
     *
     * format_vaadinDatePicker
     */
    vaadinDatePicker: vaadinDatePickerI18N.formatDate,
    vaadinDatePickerI18N: vaadinDatePickerI18N,

    /**
     * Output Example: May 8, 2020 @ 15:23:55
     *
     * format_dateTime(dateString)
     */
    dateMMDDYYYY(dateString) {
        if (!dateString)
            return "";

        const d = new Date(dateString);
        return ("00" + (d.getMonth() + 1)).slice(-2) + "/" +
            ("00" + d.getDate()).slice(-2) + "/" +
            d.getFullYear();
    },

    /**
     * Output Example: May 8, 2020 - May 9, 2020
     *                 May 8, 2020 to May 9, 2020
     * 
     * format_dateRange(startDate, endDate, "to")
     */
    dateRange(startDate, endDate, separator = "-") {
        if (!startDate || !endDate || startDate === "0001-01-01T00:00:00" || endDate === "0001-01-01T00:00:00") {
            return "";
        }
        if (startDate === endDate) {
            return this.format_date(startDate);
        }
        return `${this.format_date(startDate)} ${separator} ${this.format_date(endDate)}`;
    },

    /**
     * Formats Lot and ALot
     * 
     * format_lot
     */
    lot(lot, alot, showNegativeLot) {
        if (!showNegativeLot && lot && parseInt(lot) < 0)
            return "";
        else
            return lot.toString() + (alot ? alot : "");
    },
    lotWithSession(lot, alot, sessionDate, showNegativeLot) {
        return `${format.lot(lot, alot, showNegativeLot)} : ${format.date(sessionDate)}`;
    },
    lotWithSessionTooltip(sessionDate, sessionTitle) {
        return `${sessionTitle} : ${format.dateTime(sessionDate)}`;
    },
    jmWood_Description(year, make, companyAttribute, model, categoryID, categoryNameSingular, categoryName, vin, serialNumber, inventoryDescription, mileage, hours, additionalInfo1, additionalInfo2, notes, showTilde = true, richTextFormat = false, boldYearCompanyMakeModel = false, filterCategoryIDs = []) {

        //let filterCategoryIDs = [1000339, 1000411, 1000001, 1000005, 1000007, 1000009, 1000089, 1000015, 1001051, 1000017, 1000088, 1000032, 1000002, 1000056, 1000076, 1000140, 1000139, 1000052, 1000055, 1000059, 1000063, 1000071, 1000061, 1000116, 1000081, 1000156, 1000155, 1001056, 901542, 1000353, 1000370, 901603, 1000395, 901620, 901563, 1000398, 1000252, 1000183, 1000221, 1000220, 1000164, 1000229, 1000263, 1000264, 1000265, 1000251, 1000236, 1000165, 1000168, 1000266, 1000216, 1000214, 1000269, 1000232, 1000239, 1000179, 1000180, 1000223, 1000182, 1000240, 1000272, 1000185, 1000283, 1000188, 1000227, 1000210, 1000189, 1000230, 1000276, 1000273, 1000190, 1000191, 1000215, 1000192, 1000193, 1000291, 1000253, 1000275, 1000218, 1000197, 1000198, 1000199, 1000202, 1000259, 1000277, 1000228, 1000288, 1000278, 1000326, 1000463];
        // If null passed in, we overwrite and make it a empty array.
        if (!filterCategoryIDs) filterCategoryIDs = [];

        let category = "";
        if (filterCategoryIDs.indexOf(`${categoryID}`) == -1) {
            category = (categoryNameSingular || categoryName || '').toUpperCase();
        }

        //Joined with spaces ignoring empty values
        let yearMakeCompanyModelCategory = [year, make, companyAttribute, model, category].filter(Boolean).join(" ") + " ";

        //If any of the following attributes are provided, as well as the description, output a tilde... but only if the bool is true
        let tilde = "";
        if (showTilde && ((make || companyAttribute || model || year || serialNumber || vin) && inventoryDescription))
            tilde = "~";        

        let startBold = '', endBold = '';
        if (boldYearCompanyMakeModel) {            
            if (richTextFormat) {
                startBold = ' \\b ';
                endBold = '\\b0';
            } else {
                startBold = '<b>';
                endBold = '</b>';
            }
        }

        let desc = [`${startBold}${yearMakeCompanyModelCategory}${endBold}` + (vin ? `VIN ${vin}` : "") +
            (serialNumber ? `SN ${serialNumber}` : "") +
            tilde + ' ' + inventoryDescription,
        (parseInt(mileage) > 0 ? `Odometer Reading ${format.numberWithCommas(parseInt(mileage))} Miles` : ""),
        (parseInt(hours) > 0 ? `Meter Reading ${format.numberWithCommas(parseInt(hours))} Hours` : ""),
            additionalInfo1, additionalInfo2, notes
        ].filter(Boolean).join(", ");
        return `${desc}` || "";        
    },
    /**
     * Formats bidder/registrant name fields into a single string
     * 
     * @param {string} salutation
     * @param {string} fname
     * @param {string} mname
     * @param {string} lname
     * @param {string} suffix
     */
    bidderName(salutation, fname, mname, lname, suffix) {
        return (salutation == undefined ? '' : salutation + ' ') +
            fname + ' ' +
            (mname == undefined ? '' : mname + ' ') +
            lname +
            (suffix == undefined ? '' : ' ' + suffix);
    },
    /**
     * Strip HTML from the input string, optionally replacing <br> (or [br]) tags.
     * This was created to allow use of existing HTML strings in places where we just wanted inline text.
     *
     * Example input: "foo<br />bar<hr /> - gah"
     * Example output: "foo, bar - gah"
     */
    withoutHtml(inputStringWithHtml, brTagReplacement) {
        if (!inputStringWithHtml) {
            return "";
        }

        // Default to comma BR replacement if nothing specified.
        brTagReplacement = ((brTagReplacement === undefined) ? ", " : brTagReplacement) || "";

        return inputStringWithHtml
            .replace(/\s*\[br\\?]\s*/gmi, brTagReplacement)
            .replace(/\s*<br\s*\/?>\s*/gmi, brTagReplacement)
            .replace(/(<([^>]+)>)/gi, ""); // Remove other HTML.
    }

}